import { EntityChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/entity-with-changes.type'

export const getRawChanges = (changes: EntityChanges) =>
  Object.keys(changes).reduce((acc, key) => {
    return { ...acc, [key]: changes[key]?.new }
  }, {})
